import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectCompanyAddress,
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
} from "chart.js";
import { Calendar, Printer } from "lucide-react";
import { FromToDate } from "../../utility/component/fromToDate";
import { GetDateWiseChequeSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import { SummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
import { VoucherPrintColumns } from "./printColumns";
import VoucherPrint from "../../print/voucher";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import GeniusTableForReports from "../../utility/component/printReport";
import './printStyle.css'
import { FormatNumber2 } from "../../utility/functions/formatNumber";
ChartJS.register(ArcElement, Tooltip, Legend, LinearScale);

const DateWiseChequeSummary = () => {
  const prefix = useSelector(selectPrefix);
  const [summaryList, setSummaryList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const printRef = useRef(null);
  const [getCustomerData, setCustomerData] = useState({
    table_prefix: prefix,
    FDATE: moment(fromDate).format("YYYY-MM-DD"),
    TDATE: moment(ToDate).format("YYYY-MM-DD"),
  });
  const [voucherNo, setVoucherNo] = useState("");
  const columns = SummaryColumns(width);
  const printColumns = VoucherPrintColumns(width);

  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = () => {
    GetDateWiseChequeSummary(getCustomerData, token, dispatch, setSummaryList);
  };


  useEffect(() => {
    setCustomerData((old) => {
      return {
        ...old,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
      };
    });
  }, [fromDate, ToDate]);

  useEffect(() => {
    const callback = (details, data) => {
      setCustomerData(details[0]);
      setSummaryList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {
      console.log("nothing");
    };
    IsLocalData("date_wise_cheque_count_summary", callback, elseFunc);
  }, []);


  const totalCheques = summaryList.reduce(
    (sum, item) => sum + item.NO_OF_CHEQUES,
    0,
  );
  const totalAmount = summaryList.reduce(
    (sum, item) => sum + item.AMOUNT,
    0,
  );

  // Prepare pie chart data based on amount
  function generateRandomColors(count) {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(
        Math.random() * 256
      )}, ${Math.floor(Math.random() * 256)}, 0.6)`;
      colors.push(color);
    }
    return colors;
  }
  const bgColorList = generateRandomColors(summaryList.length)
  const Purdata = {
    labels: summaryList.map((o) =>(moment( o.CHEQUE_DATE).format("DD MMM YYYY"))),
    datasets: [
      {
        label: "Amount",
        data: summaryList.map((o) => o.AMOUNT),
        backgroundColor: bgColorList,
        hoverBackgroundColor: bgColorList,
      },
    ],
  };

  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#8884D8",
    "#82CA9D",
    "#FFC658",
  ];

  const handlePrint = useReactToPrint({
    content: ()=>printRef.current,
    pageStyle: `
      @page {
        size: portrait;
      }
      @media print {
        div[style*="display: none"] {
          display: block !important;
        }
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .print-only {
          position: static !important;
          left: auto !important;
        }
      }
    `,
  });
  const companyDetails = useSelector(selectCompanyAddress)
  console.log(companyDetails)
  return (
    <div className=" bg-white flex flex-col h-full overflow-y-auto   ">
   
      <div className=" flex flex-col h-full p-3 ">
        <div>
          {window.innerWidth <= 700 ? (
            <>
              <FromToDateMobile onPrintClick={handlePrint} submit={okButton} />
            </>
          ) : (
            <FromToDate
              hideReset={true}
              onPrintClick={handlePrint}
              submit={okButton}
              reset={() => {
                setSummaryList([]);
              }}
            />
          )}
        </div>
      
        <div className="grid grid-cols-1 mt-3   gap-6">
        <div className="lg:col-span-2 overflow-x-auto border border-gray-200 rounded-lg">
          <table className="w-full">
            <thead className="bg-gray-100 border-b border-gray-200">
              <tr>
                <th style={{
                  borderRight:"1px solid #e5e7eb"
                }} className="px-4 py-3 text-left text-sm font-semibold">
                  Cheque Date
                </th>
                <th  style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-right text-sm font-semibold">
                  Amount (₹)
                </th>
                <th style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-center text-sm font-semibold">
                  Cheque Number(s)
                </th>
                <th style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-center text-sm font-semibold">
                  No. of Cheques
                </th>
                <th style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-center text-sm font-semibold">
                  Party Name
                </th>
                <th className="px-4 py-3 text-center text-sm font-semibold">
                  Cheque Clearance Date
                </th>
              </tr>
            </thead>
            <tbody>
              {summaryList.map((row, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-100 hover:bg-gray-50"
                >
                  <td style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-sm whitespace-nowrap align-top">
                    {moment(row.CHEQUE_DATE).format(
                      "DD-MM-YYYY",
                    )}
                  </td>
                  <td style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-sm text-right whitespace-nowrap align-top">
                    {FormatNumber2(row.AMOUNT) }
                  </td>
                  <td style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-sm break-words max-w-xs align-top">
                    {row.CHEQUE_NOS}
                  </td>
                  <td style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-sm text-right whitespace-nowrap align-top">
                    {row.NO_OF_CHEQUES}
                  </td>
                  <td style={{
                  borderRight:"1px solid #e5e7eb"
                }}  className="px-4 py-3 text-sm break-words max-w-md align-top">
                    {row.PARTY_NAME}
                  </td>
                  <td className="px-4 py-3 text-sm whitespace-nowrap align-top">
                    { row.CHEQUE_CLEAR_DATE ?moment(row.CHEQUE_CLEAR_DATE).format(
                      "DD-MM-YYYY",
                    ):""}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-gray-100 border-t-2 border-gray-300">
              <tr>
                <td className="px-4 py-3 text-sm font-bold">
                  Total
                </td>
                <td className="px-4 py-3 text-sm font-bold text-right">
                  {FormatNumber2(totalAmount) }
                </td>
                <td className="px-4 py-3 text-sm font-bold"></td>
                <td className="px-4 py-3 text-sm font-bold text-right">
                  {totalCheques}
                </td>
                <td className="px-4 py-3 text-sm font-bold"></td>
                <td className="px-4 py-3 text-sm font-bold"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="border w-[800px] border-gray-200 rounded-lg p-4 bg-white">
          <h3 className="text-lg font-semibold mb-4 text-center">
            Amount Distribution
          </h3>
          <Pie data={Purdata} />
        
          <div className="mt-4 text-sm text-gray-600">
            <div className="flex justify-between mb-1">
              <span>Total Cheques:</span>
              <span className="font-semibold">
                {totalCheques}
              </span>
            </div>
            <div className="flex justify-between">
              <span>Total Amount:</span>
              <span className="font-semibold">
                ₹{totalAmount.toLocaleString("en-IN")}
              </span>
            </div>
          </div>
        </div>
      </div>

  
      </div>
    <div className=" hidden print:block">
        <div
          ref={printRef}
          id="print-component"
          className="p-1"
          style={{  fontFamily: "Arial, sans-serif",
          fontSize: 18, }}
        >
          <div   className="text-center mb-6">
            <div className="text-[19px] ">
{companyDetails?.companyName}
            </div>
            <div className="text-2xl font-bold mb-2">
              Date Wise Cheque Count Summary Report
            </div>
            <div style={{
                fontSize:18
              }} className="">
              <span style={{
                fontSize:18
              }} className="font-semibold">From: </span>
              {moment(fromDate).format("DD-MM-YYYY")}
              <span className="font-semibold ml-4">To: </span>
              {moment(ToDate).format("DD-MM-YYYY")}
            </div>
            <div className="text-xs text-gray-600 mt-1">
              Generated on:{" "}
              {moment().format("DD-MM-YYYY HH:mm:ss")}
            </div>
          </div>

          {/* Print Table */}
          <table className="border-collapse w-[1000px] mb-8" style={{ fontSize: '18px' }}>
            <thead>
              <tr className="bg-gray-200">
                <th className="border border-gray-400 px-2 py-2 text-center font-semibold" style={{ width: '33%',fontSize: '18px' }}>
                  Cheque Date
                </th>
                <th className="border border-gray-400 px-2 py-2 text-center font-semibold" style={{ width:'33%' ,fontSize: '18px' }}>
                  Amount (₹)
                </th>
              
                <th className="border border-gray-400 px-2 py-2 text-center font-semibold" style={{ width: '33%' ,fontSize: '18px' }}>
                  No. of Cheques
                </th>
            
              </tr>
            </thead>
            <tbody>
              {summaryList.map((row, index) => (
                <tr key={index}>
                  <td  style={{
                  fontSize: '18px' 
                  }} className="border border-gray-400 px-2 py-2 align-top">
                    {moment(row.CHEQUE_DATE).format(
                      "DD-MM-YYYY",
                    )}
                  </td>
                  <td style={{
                  fontSize: '18px' 
                  }} className="border border-gray-400 px-2 py-2 text-right align-top">
                    {FormatNumber2(row.AMOUNT)}
                  </td>
                
                  <td style={{
                  fontSize: '18px' 
                  }} className="border border-gray-400 px-2 py-2 text-right align-top">
                    {row.NO_OF_CHEQUES}
                  </td>
               
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-gray-200 font-bold">
                <td style={{
                  fontSize:18
                }} className="border text-right border-gray-400 px-2 py-2">
                  Total
                </td>
                <td  style={{
                  fontSize:18
                }} className="border border-gray-400 px-2 py-2 text-right">
                  {FormatNumber2(totalAmount) }
                </td>
                <td style={{
                  fontSize:18
                }}  className="border border-gray-400 px-2 py-2 text-right">
                  {totalCheques}
                </td>
              
              </tr>
            </tfoot>
          </table>

         
        </div>
      </div>
    </div>
  );
};

export default DateWiseChequeSummary;
